import { render } from "./addCustomer.vue?vue&type=template&id=7115f870&scoped=true"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"

import "./addCustomer.vue?vue&type=style&index=0&id=7115f870&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7115f870"]])

export default __exports__